
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'

import Datetime from 'vux/src/components/datetime/index.vue'


export default {
components: {
cmBlank,cmLoadmore,Popup,Group,PopupHeader,XButton,Radio,Datetime, wx
},
directives: {
TransferDom
},
data () {
return {
blankShow:false,
loadStatus:false,
dateStatus:false,
dateStatus1:false,
dateStatus2:false,
dateStatus3:false,
searchPop:false,
loadmoreText:'正在加载。。。',
busy:false,
endDate:'',
startDate:'',
endDate1:'',
startDate1:'',
endDate2:'',
startDate2:'',
endDate3:'',
startDate3:'',
dateKey:0,
dateKey1:0,
dateKey2:0,
dateKey3:0,
outIndex:'',
keyword:'',
name:'',
phone:'',
index2:0,
index3:0,
dateStatus2:0,
dateStatus3:0,
index:0,
index1:0,
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
outDays:[
{
key:3,
text:'三天以上'
},
{
key:4,
text:'四天以上'
},
{
key:5,
text:'五天以上'
},
{
key:10,
text:'十天以上'
},
],
}
},
created(){
this.startDate = '';
this.endDate = '';
this.name = '';
this.phone = '';
this.config();

},
amount(){
},
methods:{
copy(val){
this.$func.copy(val,event);
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
resetSearch(){
this.name = '';
this.phone = '';
this.keyword = '';
this.startDate = '';
this.startDate1 = '';
this.endDate = '';
this.endDate1 = '';
this.endDate2 = '';
this.startDate2 = '';
this.endDate3 = '';
this.startDate3 = '';
this.outIndex = '';
this.index2 = 0;
this.index3 = 0;
this.dateStatus = false;
this.dateStatus1 = false;
this.dateStatus2 = false;
this.dateStatus3 = false;
this.dateKey++;
this.dateKey1++;
this.dateKey2++;
this.dateKey3++;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
this.searchPop = false;
},
searchSubmit(){
this.lastId = 0;
this.pageFlag = 2;
this.list = [];
this.loadmore();
this.searchPop = false;
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}
this.dateKey++;
},
showDate1(e){
this.index1 = e;
this.dateStatus1 = true;
},
dateChange1(e){
if(this.index1 > 0){
this.endDate1 = e;
}else{
this.startDate1 = e;
}
this.dateKey1++;
},
showDate2(e){
this.index2 = e;
this.dateStatus2 = true;
},
dateChange2(e){
if(this.index2 > 0){
this.endDate2 = e;
}else{
this.startDate2 = e;
}
this.dateKey2++;
},
showDate3(e){
this.index3 = e;
this.dateStatus3 = true;
},
dateChange3(e){
if(this.index3 > 0){
this.endDate3 = e;
}else{
this.startDate3 = e;
}
this.dateKey3++;
},
outTime(index){
this.outIndex = this.outIndex === index ? '' : index;

},
getList(){
let outDay = this.outIndex !== '' ? this.outDays[this.outIndex].key : 0;
this.$api.washCode({last_id:this.lastId,page_flag:this.pageFlag,keyword:this.keyword,type:2,start:this.startDate,end:this.endDate,start1:this.startDate1,end1:this.endDate1,pick_start:this.startDate2,pick_end:this.endDate2,up_start:this.startDate3,up_end:this.endDate3,name:this.name,phone:this.phone,outDay:outDay}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
barOrder(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
scanQRCode(key,index){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{
that.keyword = that.$func.parseScanResult(res.resultStr);
that.search();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/recordList.vue